import React from 'react'
import styled, {css} from 'styled-components'
import {AccessibleText} from '../../utils'

const Hamburger = styled.button`
  padding: 7px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0 7px 0 -10px;
  overflow: visible;
  transform: scale(.7);
  
  &:hover { opacity: 0.7; }
`

const HamburgerBox = styled.div`
  width: 32px;
  height: 20px;
  display: inline-block;
  position: relative;
`

const HamburgerInner = styled.div`
  display: block;
  top: 50%;
  margin-top: -2px;
  top: 2px;
  transition-duration: 0.275s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  
  &, &:before, &:after {
    width: 32px;
    height: 4px;
    background-color: ${props => props.theme.colors.primary.base};
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }
  
  &:before, &:after {
    content: "";
    display: block;
  }
  
  &:before {
    top: 10px;
    transition: opacity 0.125s 0.275s ease;
  }
  
  &:after {
    top: 20px;
    transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  
  ${({isActive}) => (isActive ? css`
    transform: translate3d(0, 10px, 0) rotate(135deg);
    transition-delay: 0.075s;
  
    &:before {
      transition-delay: 0s;
      opacity: 0;
    }
    
    &:after {
      transform: translate3d(0, -20px, 0) rotate(-270deg);
      transition-delay: 0.075s;
    }
  ` : '')}
`

const BurgerButton = ({label, isActive, ...rest}) => (
  <Hamburger {...rest} aria-expanded={isActive}>
    <HamburgerBox>
      <HamburgerInner isActive={isActive} />
    </HamburgerBox>
    <AccessibleText>
      {label}
    </AccessibleText>
  </Hamburger>
)

export default BurgerButton
